import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, Injector, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { DataColumn } from '@farris/ui-common/column';

export interface ITemplateComponent {
    ctx: any,
    renderContext?: any;
}

export type ComponentTemplateFn = () => Partial<ITemplateComponent> | ComponentRef<Partial<ITemplateComponent>>;
export type ComponentTemplateRef = Partial<ITemplateComponent> | ComponentRef<Partial<ITemplateComponent>> | ComponentTemplateFn;

@Directive({ selector: '[component-template]' })
export class FarrisComponentTemplateDirective implements OnInit, OnChanges {

    @Input('component-template') column: DataColumn;
    @Input() cmpRef: ComponentRef<any> = null;

    @Input() ctx: any;
    @Input() renderContext: any

    @Input() templateType: 'head'|'cell'|'footer'|'empty'|'normal' = 'cell';
    templateComponentIns: ComponentRef<any>;
    constructor(private injector: Injector, private el: ElementRef, private cfr: ComponentFactoryResolver) { }

    ngOnInit() {
        this.renderTemplate();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.ctx && !changes.ctx.isFirstChange()) {
            this._expandCtxToThis();
        }
    }


    private _expandCtxToThis() {
        this.expandContext(this.ctx);
        this.expandContext(this.renderContext);
    }

    private expandContext(ctx: any) {
        if (this.templateComponentIns && ctx) {
            Object.keys(ctx).forEach(n => {
                this.templateComponentIns.instance[n] = ctx[n];
            });
        }
    }

    private renderTemplate() {
        this.templateComponentIns = this._getCmpRef();
        if (this.templateComponentIns) {
            this._expandCtxToThis();
            this.templateComponentIns.instance.ctx = this.ctx;
            this.el.nativeElement.append(this.templateComponentIns.location.nativeElement);
            this.templateComponentIns.changeDetectorRef.detectChanges();
        }
    }

    private _getCmpRef() {
        if (this.cmpRef) {
            return this.createInstance(this.cmpRef);
        }

        if (this.column) {
            if (this.templateType == 'cell') {
                if (this.column.componentType) {
                    return this.createInstance(this.column.componentType);
                }
            } else {
                if (this.column.headerComponentType) {
                    return this.createInstance(this.column.headerComponentType);
                }
            }
        }

        return null;
    }

    private createInstance(cmptype: any): ComponentRef<any> {

        if (!cmptype) {
            return null;
        }

        let templateComponentIns = null;
        if (!cmptype.ngBaseDef && typeof cmptype === 'function') {
            templateComponentIns = cmptype();
        } else {
            if (!cmptype['instance']) {
                const cellTemplateCmp = this.cfr.resolveComponentFactory(cmptype as any);
                templateComponentIns = cellTemplateCmp.create(this.injector);
            } else {
                templateComponentIns = cmptype;
            }
        }

        return templateComponentIns
    }
}
